import React from 'react';
import { Link, Paper, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { useL10n } from '@uplift/hooks';
import { AppointmentSmsOptInCheckbox } from './appointment-sms-opt-in-checkbox.component';

export const AppointmentRemindersDisclosure: React.VFC = () => {
  const { classes } = useStyles();
  const l10n = useL10n();

  return (
    <Paper variant="outlined" className={classes.root}>
      <AppointmentSmsOptInCheckbox
        body={(
          <Typography variant="body2" color="textPrimary">
            {l10n.phoneValidationModal.textAlertDisclosure.appointmentSmsOptIn.body}{' '}
            {l10n.phoneValidationModal.textAlertDisclosure.seeOur}{' '}
            <Link href={l10n.general.privacyUrl} color="inherit" underline="always" target="_blank" rel="noreferrer">
              {l10n.general.privacy}
            </Link> and <Link href={l10n.general.termsUrl} color="inherit" underline="always" target="_blank" rel="noreferrer">
              {l10n.general.terms}
            </Link>.
          </Typography>
        )}
      />
    </Paper>
  );
};

const useStyles = makeStyles({ name: 'AppointmentRemindersDisclosure' })(theme => ({
  root: {
    padding: theme.spacing(2),
    backgroundColor: theme.palette.secondary.background,
    borderColor: theme.palette.secondary.border,
  },
}));
